import { GET_ASSIGNED_ASSETS } from 'actions/types';
import { transformActions } from 'utils/';

const initialState = {
  data: [],
  isLoading: false,
};

/**
  @description Stores assigned assets array details in redux state
  @param {[]} state
  @param {{}} action
  @returns {[]}
 */
function assignedAssets(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_ASSIGNED_ASSETS];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');

  if (type === GET_ASSIGNED_ASSETS) {
    return {
      data: [],
      isLoading: true,
    };
  }

  if (success.includes(type)) {
    return {
      data: payload,
      isLoading: false,
    };
  }

  if (failure.includes(type)) {
    return {
      data: [],
      isLoading: false,
    };
  }

  return state;
}

export default assignedAssets;
